module.exports = __webpack_public_path__ + "media/images/landslide_icon-bd4e584609d8d3d24f4c59e93b8c714f.png";